export const email = /^[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const emailWithBoundaries = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

export const phone = /^\+7 \(\d{3}\) \d{3} \d{4}$/;
